<ng-container *ngIf="facetsData$ | async as facetList">
  <ng-container *ngIf="facetList.activeFacets?.length > 0">
    <a
      tabindex="0"
      *ngFor="let facet of facetList?.activeFacets"
      [routerLink]="
        { cxRoute: 'search', params: { query: facetList.currentSearchQuery } }
          | cxUrl
      "
      queryParamsHandling="merge"
      class="mb-2 active-facet"
      data-cy="activeFacet"
      [queryParams]="getLinkParams(facet)"
      [cxFocus]="{ key: getFocusKey(facetList, facet) }"
      role="button"
      (keydown.space)="removeFilterWithSpacebar($event)"
      [attr.aria-label]="
        'rrs.productListing.activeFilter'
          | cxTranslate: { filter: facet.facetValueName }
      ">
      <rrs-filter-tag
        [closeable]="true"
        [name]="getTranslationKey(facet.facetName) | cxTranslate"
        [option]="facet.facetValueName | uppercase"></rrs-filter-tag>
    </a>
    <a
      [routerLink]="{ cxRoute: 'search' } | cxUrl"
      [queryParams]="{ facetFilters: null, currentPage: null }"
      queryParamsHandling="merge"
      class="clear d-none d-lg-block"
      data-cy="clearFacets">
      {{ 'rrs.productListing.clearAllFilters' | cxTranslate }}
    </a>
  </ng-container>
</ng-container>
